import BitgetPartnership from "@/components/BitgetPartnership";
import SEO from "@/components/SEO";

const Bitget = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <SEO 
        title="Bitget Partnership - $ORX Token Exchange Integration | Oraculus:X"
        description="Learn about our strategic partnership with Bitget exchange. Seamless $ORX token trading, exclusive benefits, and enhanced liquidity for our community."
      />
      <div className="fixed inset-0 bg-gradient-mesh animate-mesh-move opacity-40" />
      <div className="fixed inset-0 bg-gradient-opal-radial animate-gradient-shift" style={{ backgroundSize: '200% 200%' }} />
      
      <main className="relative z-10 pt-20 md:pt-32">
        <BitgetPartnership />
      </main>
    </div>
  );
};

export default Bitget;
